export const formatDate = (inputDate: string | null): string => {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = String(date.getUTCFullYear());

  return `${day}/${month}/${year}`;
};

export const parseDate = (dateString: string) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date format');
  }
  return date;
};

export const formatDateRange = (
  startDateString: string,
  endDateString: string,
  yearLabel: string,
  monthLabel: string,
): string => {
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();
  const startMonth = startDate.toLocaleString('default', { month: 'short' });
  const endMonth = endDate.toLocaleString('default', { month: 'short' });

  const yearDiff = endYear - startYear;
  const monthDiff = endDate.getMonth() - startDate.getMonth();

  let result = `${startMonth} ${startYear}`;
  if (yearDiff > 0 || monthDiff > 0) {
    result += ` - ${endMonth} ${endYear}`;
  }

  const totalMonths = yearDiff * 12 + monthDiff;
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  if (years > 0 || months > 0) {
    const yearLabelPart = years > 0 ? `${years} ${yearLabel}` : '';
    const monthLabelPart = months > 0 ? `${months} ${monthLabel}` : '';
    const separator = years > 0 && months > 0 ? ', ' : '';

    result += ` (${yearLabelPart}${separator}${monthLabelPart})`;
  }

  return result;
};
